<template>
  <v-app-bar app dense clipped-left color="primary" class="pl-0"  style="cursor: pointer;">
    <!-- <v-btn v-if="isUser" text icon @click.ctrl.exact="toggleSidebar('toggle')">
      <v-icon>view_module</v-icon>
    </v-btn> -->
    <v-toolbar-title class="white--text">context</v-toolbar-title>
    <!-- <v-spacer></v-spacer> -->
    <!-- <context-search></context-search>
    <v-btn @click="createNewContextHandler()" text :loading="creatingNewContext"
      ><v-icon>add</v-icon> New Context</v-btn
    > -->
    <v-col class="pa-0 pl-8 fluid">
      <quick-search></quick-search>
    </v-col>
    <v-spacer></v-spacer>
    <v-toolbar-items v-if="isUser">
      <v-menu bottom origin="top right" transition="v-scale-transition" key="profileMenu">
        <template v-slot:activator="{ on }">
          <v-btn dark icon v-on="on">
            <user-avatar size="25px" class="grey lighten-4" :avatarUrl="avatar"></user-avatar>
          </v-btn>
        </template>
        <v-list>
          <v-list-item> <v-list-item-title>Change Account</v-list-item-title> </v-list-item>
          <v-list-item> <v-list-item-title>Invite Friends</v-list-item-title> </v-list-item>
          <v-list-item @click="logout">
            <v-list-item-title>Sign Out</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-toolbar-items>
    <v-toolbar-items v-else-if="$route.name !== 'landingPage'" class="">
      <v-menu :close-on-content-click="false" :nudge-width="200" key="Sig in menu" offset-x>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" text>
            Sign in / Sign up
          </v-btn>
        </template>

        <v-card class="pa-2">
          <auth />
        </v-card>
      </v-menu>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
import { isUser, avatar, logout } from '@/store/useAuth';
// import JoinForm from './auth/JoinForm';
// import SignInForm from './auth/SignInForm.vue';
import Auth from '../Auth';
import UserAvatar from '../UserAvatar';
import QuickSearch from '@/views/Context/components/ContextSearch/QuickSearch';

export default {
  name: 'AppHeader',
  components: {
    // JoinForm,
    // SignInForm,
    QuickSearch,
    UserAvatar,
    Auth
  },
  setup() {
    return { logout, avatar, isUser };
  },
  data() {
    return {
      signupDialog: false,
      loginDialog: false,
      creatingNewContext: false
    };
  },
  methods: {
    // ...mapMutations('components/explorerSidebar', ['toggleSidebar']),
    cancelSignin: function() {
      this.loginDialog = false;
    }
  }
};
</script>

<style>
.toolbar__title {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0.02em;
  margin-left: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
